module.exports = __webpack_public_path__ + "static/media/frozen-food.62ab910e.jpg";